export enum Page {
  Home,
  Chatbot,
  Search,
  Article,
}
